export const PROVINCES = [
  { name: "Abra", region: "CAR", key: "ABR" },
  { name: "Agusan del Norte", region: "XIII", key: "AGN" },
  { name: "Agusan del Sur", region: "XIII", key: "AGS" },
  { name: "Aklan", region: "VI", key: "AKL" },
  { name: "Albay", region: "V", key: "ALB" },
  { name: "Antique", region: "VI", key: "ANT" },
  { name: "Apayao", region: "CAR", key: "APA" },
  { name: "Aurora", region: "III", key: "AUR" },
  { name: "Basilan", region: "ARMM", key: "BAS" },
  { name: "Bataan", region: "III", key: "BAN" },
  { name: "Batanes", region: "II", key: "BTN" },
  { name: "Batangas", region: "IV-A", key: "BTG" },
  { name: "Benguet", region: "CAR", key: "BEN" },
  { name: "Biliran", region: "VIII", key: "BIL" },
  { name: "Bohol", region: "VII", key: "BOH" },
  { name: "Bukidnon", region: "X", key: "BUK" },
  { name: "Bulacan", region: "III", key: "BUL" },
  { name: "Cagayan", region: "II", key: "CAG" },
  { name: "Camarines Norte", region: "V", key: "CAN" },
  { name: "Camarines Sur", region: "V", key: "CAS" },
  { name: "Camiguin", region: "X", key: "CAM" },
  { name: "Capiz", region: "VI", key: "CAP" },
  { name: "Catanduanes", region: "V", key: "CAT" },
  { name: "Cavite", region: "IV-A", key: "CAV" },
  { name: "Cebu", region: "VII", key: "CEB" },
  { name: "Compostela Valley", region: "XI", key: "COM" },
  { name: "Cotabato", region: "XII", key: "NCO" },
  { name: "Davao del Norte", region: "XI", key: "DAV" },
  { name: "Davao del Sur", region: "XI", key: "DAS" },
  { name: "Davao Occidental", region: "XI", key: "DAC" },
  { name: "Davao Oriental", region: "XI", key: "DAO" },
  { name: "Dinagat Islands", region: "XIII", key: "DIN" },
  { name: "Eastern Samar", region: "VIII", key: "EAS" },
  { name: "Guimaras", region: "VI", key: "GUI" },
  { name: "Ifugao", region: "CAR", key: "IFU" },
  { name: "Ilocos Norte", region: "I", key: "ILN" },
  { name: "Ilocos Sur", region: "I", key: "ILS" },
  { name: "Iloilo", region: "VI", key: "ILI" },
  { name: "Isabela", region: "II", key: "ISA" },
  { name: "Kalinga", region: "CAR", key: "KAL" },
  { name: "La Union", region: "I", key: "LUN" },
  { name: "Laguna", region: "IV-A", key: "LAG" },
  { name: "Lanao del Norte", region: "X", key: "LAN" },
  { name: "Lanao del Sur", region: "ARMM", key: "LAS" },
  { name: "Leyte", region: "VIII", key: "LEY" },
  { name: "Maguindanao", region: "ARMM", key: "MAG" },
  { name: "Marinduque", region: "IV-B", key: "MAD" },
  { name: "Masbate", region: "V", key: "MAS" },
  { name: "Metro Manila", region: "NCR", key: "MM" },
  { name: "Misamis Occidental", region: "X", key: "MSC" },
  { name: "Misamis Oriental", region: "X", key: "MSR" },
  { name: "Mountain Province", region: "CAR", key: "MOU" },
  { name: "Negros Occidental", region: "VI", key: "NEC" },
  { name: "Negros Oriental", region: "VII", key: "NER" },
  { name: "Northern Samar", region: "VIII", key: "NSA" },
  { name: "Nueva Ecija", region: "III", key: "NUE" },
  { name: "Nueva Vizcaya", region: "II", key: "NUV" },
  { name: "Occidental Mindoro", region: "IV-B", key: "MDC" },
  { name: "Oriental Mindoro", region: "IV-B", key: "MDR" },
  { name: "Palawan", region: "IV-B", key: "PLW" },
  { name: "Pampanga", region: "III", key: "PAM" },
  { name: "Pangasinan", region: "I", key: "PAN" },
  { name: "Quezon", region: "IV-A", key: "QUE" },
  { name: "Quirino", region: "II", key: "QUI" },
  { name: "Rizal", region: "IV-A", key: "RIZ" },
  { name: "Romblon", region: "IV-B", key: "ROM" },
  { name: "Samar", region: "VIII", key: "WSA" },
  { name: "Sarangani", region: "XII", key: "SAR" },
  { name: "Siquijor", region: "VII", key: "SIG" },
  { name: "Sorsogon", region: "V", key: "SOR" },
  { name: "South Cotabato", region: "XII", key: "SCO" },
  { name: "Southern Leyte", region: "VIII", key: "SLE" },
  { name: "Sultan Kudarat", region: "XII", key: "SUK" },
  { name: "Sulu", region: "ARMM", key: "SLU" },
  { name: "Surigao del Norte", region: "XIII", key: "SUN" },
  { name: "Surigao del Sur", region: "XIII", key: "SUR" },
  { name: "Tarlac", region: "III", key: "TAR" },
  { name: "Tawi-tawi", region: "ARMM", key: "TAW" },
  { name: "Zambales", region: "III", key: "ZMB" },
  { name: "Zamboanga del Norte", region: "IX", key: "ZAN" },
  { name: "Zamboanga del Sur", region: "IX", key: "ZAS" },
  { name: "Zamboanga Sibugay", region: "IX", key: "ZSI" },
];

export default PROVINCES;
